/**
 * Servicio que se encarga del manejo de las peticiones sobre ayuda de enrutamiento en buscador 
 * CESAR AUGUSTO-2019-03-08
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service'; 
import { ToastrService } from 'ngx-toastr'; 
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class HeaderService {

  PATH = new ConfigService().obtenerPath();

  modulos =[
    { modulo :'Marca'},
    { modulo :'Familia'},
    { modulo :'Equipos'},
    { modulo :'Componentes'},
    { modulo :'Centro de Costo'},
    { modulo :'Tipo de Servicio'},
    { modulo :'Medio Soporte'},
    { modulo :'Estado Pqr'},
    { modulo :'Tipo Parada'},
    { modulo :'Tipo actividad'},
    { modulo :'Tipo Incidencia'},
    { modulo :'Dependencias'},
    { modulo :'Profesiones'},
    { modulo :'Tipo terceros'},
    { modulo :'logo empresa'},
    { modulo :'Ubicaciones'},
    { modulo :'Zonas'},
    { modulo :'Tipo gasto'},
    { modulo :'Perfiles'},
    { modulo :'Usuarios'},
    { modulo :'Rastreo'},
    // { modulo :'Lista chequeo'},
    { modulo :'Configuracion'},
    { modulo :'Dashboard'},
    { modulo :'Informe'},
    { modulo :'Informe incidencia'},
    { modulo :'Informe tecnicos detallado'},
    { modulo :'Informe tecnicos totalizado'},
    { modulo :'Administracion'},
    { modulo :'Item componente'},
    { modulo :'Historial de Componente'},
    { modulo :'Cliente'},
    { modulo :'Proveedor'},
    { modulo :'Empleado'},
    { modulo :'Gestion Incidencias'},
    { modulo :'Pqr'},
    { modulo :'Solicitudes compra'},
    { modulo :'Evidencias fotograficas'},
    { modulo :'Geolocalizacion'},
    { modulo :'Gestion gastos'},
    { modulo :'Agendamiento'},
  ]

  constructor(
    private http        : Http,
    private router      : Router,
    private toastr      : ToastrService,
    private _key        : KeyService
  ) {}


  /**
   * Obtener listado de familias
   * JMM-2018-06-25
   */
  conexionService(dataconexion)
  {
    let url = this.PATH+'/api/header';
    return this.http.post(url, dataconexion, {headers:this._key.head()}).map(resp => resp.json());
  }// .conexionService()


  rutasModule(modulos,listpermisos){
    
    modulos == 'Marca'                    ? ((listpermisos['configuracion_gestionproductos_marcas'] == true) ? this.rediret(['main/marcas', 'modmarcas']) : this.alert() ) : '';
    modulos == 'Familia'                  ? ((listpermisos['configuracion_gestionproductos_familias'] == true) ? this.rediret(['main/familias', 'modfamilias']) : this.alert() ) : '';
    modulos == 'Equipos'                  ? ((listpermisos['configuracion_gestionproductos_equipos'] == true) ? this.rediret(['main/equipos']) : this.alert() ) : '';
    modulos == 'Componentes'              ? ((listpermisos['configuracion_gestionproductos_componentes'] == true) ? this.rediret(['main/componentes','modcomponentes']) : this.alert() ) : '';
    modulos == 'Centro de Costo'          ? ((listpermisos['configuracion_gestionempresa_centrosdecosto'] == true) ? this.rediret(['main/centcost']) : this.alert() ) : '';
    modulos == 'Tipo de Servicio'         ? ((listpermisos['configuracion_gestionincidencias_tiposdeservicio'] == true) ? this.rediret(['main/pqr','tiposervicio']) : this.alert() ) : '';
    modulos == 'Medio soporte'            ? ((listpermisos['configuracion_gestionincidencias_mediosdesoporte'] == true) ? this.rediret(['main/pqr','mediosoporte']) : this.alert() ) : '';
    modulos == 'Estado Pqr'               ? ((listpermisos['configuracion_gestionincidencias_estadosdeincidencia'] == true) ? this.rediret(['main/pqr','estadopqr']) : this.alert() ) : '';
    modulos == 'Tipo Parada'              ? ((listpermisos['configuracion_gestionincidencias_tipoparada'] == true) ? this.rediret(['main/pqr','tipoparada']) : this.alert() ) : '';
    modulos == 'Tipo actividad'           ? ((listpermisos['configuracion_gestionincidencias_tipoactividad'] == true) ? this.rediret(['main/pqr','tipoactividad']) : this.alert() ) : '';
    modulos == 'Tipo Incidencia'          ? ((listpermisos['configuracion_gestionincidencias_tipopqr'] == true) ? this.rediret(['main/pqr','tipopqr']) : this.alert() ) : '';
    modulos == 'Dependencias'             ? ((listpermisos['configuracion_gestionempresa_dependencias'] == true) ? this.rediret(['main/dependencia']) : this.alert() ) : '';
    modulos == 'Profesiones'              ? ((listpermisos['configuracion_gestionempresa_dependencias'] == true) ? this.rediret(['main/profesiones']) : this.alert() ) : '';
    modulos == 'Tipo terceros'            ? ((listpermisos['configuracion_gestionempresa_clasificaciontercero'] == true) ? this.rediret(['main/tipoterceros']) : this.alert() ) : '';
    modulos == 'logo empresa'             ? ((listpermisos['configuracion_gestionempresa_administradordeimagenes'] == true) ? this.rediret(['main/logo-empresa']) : this.alert() ) : ''; 
    modulos == 'Ubicaciones'              ? ((listpermisos['configuracion_gestionubicaciones'] == true) ? this.rediret(['main/ubicaciones','0','0','0','0','0']) : this.alert() ) : '';
    modulos == 'Zonas'                    ? ((listpermisos['configuracion_gestionubicaciones_zonas'] == true) ? this.rediret(['main/zonas']) : this.alert() ) : '';   
    modulos == 'Tipo gasto'               ? ((listpermisos['configuracion_gestioncomprasgastos_conceptodegastos'] == true) ? this.rediret(['main/tipo-gasto']) : this.alert() ) : ''; 
    modulos == 'Perfiles'                 ? ((listpermisos['configuracion_gestionusuarios__perfilesypermisos'] == true) ? this.rediret(['main/perfiles']) : this.alert() ) : ''; 
    modulos == 'Usuarios'                 ? ((listpermisos['configuracion_gestionusuarios_usuarios'] == true) ? this.rediret(['main/usuarios']) : this.alert() ) : ''; 
    modulos == 'Rastreo'                  ? ((listpermisos['configuracion_gestionusuarios_auditoriayrastreo'] == true) ? this.rediret(['main/rastreo']) : this.alert() ) : '';
    modulos == 'Lista chequeo'            ? this.rediret(['main/listachequeo']) : '';
    modulos == 'Configuracion'            ? ((listpermisos['configuracion'] == true) ? this.rediret(['main/configuracion']) : this.alert() ) : '';
    modulos == 'Dashboard'                ? this.rediret(['main/dashboard']) : '';
    modulos == 'Informe'                  ? ((listpermisos['informes'] == true) ? this.rediret(['main/informe']) : this.alert() ) : '';
    modulos == 'Informe incidencia'       ? ((listpermisos['informes_informes_informedeincidencias'] == true) ? this.rediret(['main/informe','informe-incidencia']) : this.alert() ) : '';
    modulos == 'Informe tecnicos detallado'? this.rediret(['main/informe','informe-tecnicos']) : '';
    modulos == 'Informe tecnicos totalizado'? this.rediret(['main/informe','informe-tecnicos-totalizado']) : '';
    modulos == 'Administracion'           ? ((listpermisos['administracion'] == true) ? this.rediret(['main/administracion']) : this.alert() ) : '';
    modulos == 'Item componente'          ? ((listpermisos['administracion_productos_itemcomponente'] == true) ? this.rediret(['main/itemcomponente']) : this.alert() ) : '';
    modulos == 'Historial de Componente'  ? ((listpermisos['administracion_productos_historialcomponentes'] == true) ? this.rediret(['main/componentes-equipo']) : this.alert() ) : '';
    modulos == 'Cliente'                  ? ((listpermisos['administracion_empresa_cliente'] == true) ? this.rediret(['main/enrutamientos/enrutamientoterceros/null/null/Cliente']) : this.alert() ) : '';
    modulos == 'Proveedor'                ? ((listpermisos['administracion_empresa_proveedor'] == true) ? this.rediret(['main/enrutamientos/enrutamientoterceros/null/null/Proveedor']) : this.alert() ) : '';
    modulos == 'Empleado'                 ? ((listpermisos['administracion_empresa_empleado'] == true) ? this.rediret(['main/enrutamientos/enrutamientoterceros/null/null/Empleado']) : this.alert() ) : '';
    modulos == 'Gestion Incidencias'      ? ((listpermisos['incidencias_gestiondeincidencias'] == true) ? this.rediret(['main/control-incidencias']) : this.alert() ) : '';
    modulos == 'Pqr'                      ? ((listpermisos['incidencias'] == true) ? this.rediret(['main/pqr']) : this.alert() ) : '';
    modulos == 'Solicitudes compra'       ? ((listpermisos['incidencias_gestiondeincidencias_gestiondesolicitudesdecompra'] == true) ? this.rediret(['main/solicitudes-compra']) : this.alert() ) : '';
    modulos == 'Evidencias fotograficas'  ? ((listpermisos['incidencias_gestiondeincidencias_evidenciasfotograficas'] == true) ? this.rediret(['main/evidencias-fotograficas']) : this.alert() ) : '';
    modulos == 'Geolocalizacion'          ? ((listpermisos['incidencias_gestiondeincidencias_geolocalizacion'] == true) ? this.rediret(['main/geolocalizacion']) : this.alert() ) : '';
    modulos == 'Gestion gastos'           ? ((listpermisos['incidencias_gestiondeincidencias_gestiondegastos'] == true) ? this.rediret(['main/gestion-gastos']) : this.alert() ) : '';
    modulos == 'Agendamiento'             ? ((listpermisos['incidencias_gestiondeincidencias_agendamiento'] == true) ? this.rediret(['main/agendamiento-app','modagendamiento']) : this.alert() ) : '';
  }
  
  rediret(ruta){
    this.router.navigate(ruta, { replaceUrl: true });  
  }
  alert(){
    this.toastr.warning('No tiene Permisos para ingresar a esta opción ', '', { timeOut: 3000 });
  }

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/header/header.service.ts